import { createFeatureSelector, createSelector } from "@ngrx/store";
import { MenuUsuarioState } from "./menu-usuario.reducer";

export const menuUsuarioState = createFeatureSelector<MenuUsuarioState>( "menu-usuario" );

export const menuUsuarioAlreadyInitialized = createSelector(
	menuUsuarioState,
	state => state.comprobanteTesoreriaProfesionalIds != null && state.capitaPacienteTotal != null && state.aportePlanSaludYears != null
);

export const menuUsuarioOnInit = createSelector(
	menuUsuarioState,
	menuUsuarioAlreadyInitialized,
	( state, alreadyInit ) => !alreadyInit && ( !state.comprobanteTesoreriaReady || !state.capitaPacienteReady || !state.aportePlanSaludReady )
);

export const menuUsuarioComprobantesTesoreriaProfesionalIds = createSelector(
	menuUsuarioState,
	state => state.comprobanteTesoreriaProfesionalIds
);

export const menuUsuarioAportePlanSaludEnabled = createSelector(
	menuUsuarioState,
	state => state.aportePlanSaludYears && state.aportePlanSaludYears.length > 0
);

export const menuUsuarioAportePlanSaludYearsReady = createSelector(
	menuUsuarioState,
	state => state.aportePlanSaludReady
);

export const menuUsuarioAportePlanSaludYears = createSelector(
	menuUsuarioState,
	state => state.aportePlanSaludYears
);

export const menuUsuarioComprobanteTesoreriaEnabled = createSelector(
	menuUsuarioState,
	state => state.comprobanteTesoreriaProfesionalIds && state.comprobanteTesoreriaProfesionalIds.length > 0
)

export const menuUsuarioCapitaPacienteEnabled = createSelector(
	menuUsuarioState,
	state => state.capitaPacienteTotal && state.capitaPacienteTotal > 0
)

export const menuUsuarioCapitaPacienteTotal = createSelector(
	menuUsuarioState,
	state => state.capitaPacienteTotal
)

export const menuUsuarioIdPersonaSelected = createSelector(
	menuUsuarioState,
	state => state.idPersonaSelected
);